/**
 * Müvekkiller domaininin BÖLÜMLERİ (D03 — CLOS-875).
 *
 * Kayıt `contractSections.ts` ve `organizationSections.ts` ile AYNI kuralları taşıyor:
 * yetkisi olmayan bölüm çizilmez, sıra sabittir. Yeni bir desen icat edilmedi.
 *
 * ### ⚠ NEDEN ŞİMDİ DOĞDU
 *
 * Müvekkiller bugüne kadar tek sayfaydı ve kabuğa ihtiyaç yoktu. CLOS-875 ikinci bir
 * yüzey getiriyor: müvekkil kaydına BAĞSIZ gelen hizmet talepleri. O talep henüz bir
 * müvekkile bağlı olmadığı için `/app/muvekkiller/:id` altında adreslenemiyor — kendi
 * sayfası olmak zorunda, ve oraya girilecek bir kapı olmadan yazmak, kartın kapattığı
 * kusurun (ekransız uç) aynısını üretirdi.
 *
 * ⚠ Sidebar'a YENİ DOMAIN eklenmiyor (CLOS-96 altı domain): bu bir alt sayfa.
 *
 * ⚠ Görünürlük bir GÜVENLİK SINIRI DEĞİL: gerçek kapı her uçtaki `requirePermission`.
 */

export interface ClientSection {
  key: string;
  label: string;
  route: string;
  /** Gerektiren yetki; `null` ise bölüm herkese açık. */
  permission: string | null;
}

/** ⚠ SIRA KANONİKTİR. Yeni bölüm araya değil, kartının söylediği yere girer. */
export const CLIENT_SECTIONS: readonly ClientSection[] = [
  {
    key: "list",
    label: "Tüm Müvekkiller",
    route: "/app/muvekkiller",
    permission: "client.view",
  },
  /**
   * ⚠ Kapı `client.workspace` — UCUN kapısıyla aynı (`clients/routes.ts`). Alanı KURAN
   * yetki listeyi de görüyor; `client.view` ile açsaydık müvekkil listesini görebilen
   * herkes büronun ticari hak kullanımını okurdu.
   */
  {
    key: "sponsored-workspaces",
    label: "Sponsorlu Alanlar",
    route: "/app/muvekkiller/sponsorlu-alanlar",
    permission: "client.workspace",
  },
];

export function visibleClientSections(
  can: (permission: string) => boolean,
  sections: readonly ClientSection[] = CLIENT_SECTIONS,
): ClientSection[] {
  return sections.filter((s) => s.permission === null || can(s.permission));
}
